import { render } from "./BaseLoadingShimmerElement.vue?vue&type=template&id=6ce41ff4&scoped=true"
import script from "./BaseLoadingShimmerElement.vue?vue&type=script&lang=js"
export * from "./BaseLoadingShimmerElement.vue?vue&type=script&lang=js"

import "./BaseLoadingShimmerElement.vue?vue&type=style&index=0&id=6ce41ff4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce41ff4"]])

export default __exports__